// extracted by mini-css-extract-plugin
export default {"page":"HomePage_page__VB1EH","title":"HomePage_title__BSXsO","subtitle":"HomePage_subtitle__0REoq"};